import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '../store'
import qs from 'qs'
import { setting } from '@/config/config'
import { refresh } from '@/apis/oms/common'
import { refresh as be_refresh } from '@/apis/backend/common'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: setting.mockData ? setting.mockbasePath : setting.basePath,
  timeout: setting.timeout // 请求超时时间
})



// request拦截器
service.interceptors.request.use(
  config => {
    var token = store.state.userInfo.token;
    if (token){
      config.headers['Authorization'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = 'application/json'
    config.yurl = config.url
    config.yParams = config.params;
    // get参数编码
    let url = setting.mockData ? config.mockPath : config.url;
    let method = setting.mockData ? 'get' : config.method
    //如果是B端后台url加?sub-domain= 
    if (process.env.VUE_APP_TYPE == 'backend') {
      if (store.state.common.subDomain && store.state.common.subDomain != '') {
        if (config.params) {
          config.params['sub-domain'] = store.state.common.subDomain
        } else {
          config.params = { 'sub-domain': store.state.common.subDomain };
        }
      }
    }
    
    //如果是B端后台开发环境url加?sub-domain= 
    // if (process.env.NODE_ENV == 'development' && process.env.VUE_APP_TYPE == 'backend') {
    //   if (config.params) {
    //     config.params['sub-domain'] = 'test01'
    //   } else {
    //     config.params = { 'sub-domain': 'test01' };
    //   }
    // } 

    if (setting.mockData) { 
      if (config.params || config.data) {
        config.params = { ...config.params, ...config.data }
      }
      
    }
    if (method === 'get' && config.params) {
      url = url + '?' + qs.stringify(config.params, { indices: false })
      config.params = {}
    }
    config.url = url
    config.method = method

    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  async response =>  {
    const code = response.status
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.message
      })
      return Promise.reject('error')
    } else {
      if (response.data.code !== 0) {
        if (response.data.code == 100202) {
          let refreshAPI = process.env.VUE_APP_TYPE == 'oms' ? refresh : be_refresh;
          // refreshAPI(store.state.userInfo.refreshToken).then(data => {
          //   store.dispatch('update_token', data).then(() => {
          //     response.config.url = response.config.yurl
          //     response.config.params = response.config.yParams
          //     const originalRequest = response.config;
          //     return service(originalRequest)
          //   })
          // })
          const data = await refreshAPI(store.state.userInfo.refreshToken)
          await store.dispatch('update_token', data);
          response.config.url = response.config.yurl
          response.config.params = response.config.yParams
          const originalRequest = response.config;
          return service(originalRequest)
        } else {
          Message.error({
            message: response.data.message,
            duration: 5000
          })
          return Promise.reject(response.data.message)
        }
      } else {
        return response.data.data;
      }
    }
  },
  error => {
    let code = 0
    try {
      code = error.response.data.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notification.error({
          title: '网络请求超时',
          duration: 5000
        })
        return Promise.reject(error)
      }
    }
    if (code) {
      //令牌过期刷新令牌后重新执行
      // if (code === 100202) {
      //   //   MessageBox.confirm(
      //   //     '登录状态已过期，您可以继续留在该页面，或者重新登录',
      //   //     '系统提示',
      //   //     {
      //   //       confirmButtonText: '重新登录',
      //   //       cancelButtonText: '取消',
      //   //       type: 'warning'
      //   //     }
      //   //   ).then(() => {
      //   //     store.dispatch('LogOut').then(() => {
      //   //       location.reload() // 为了重新实例化vue-router对象 避免bug
      //   //     })
      //   //   })
       
      // } else if (code === 403) {
      //   this.$router.push({ path: '/401' });
      // } else {
        const errorMsg = error.response.data.message
        if (errorMsg !== undefined) {
          Message.error({
            message: errorMsg,
            duration: 5000
          })
        }
      // }
    } else {
      Message.error({
        message: '接口请求失败',
        duration: 5000
      })
    }
    return Promise.reject(error)
  }
)
export default service
